module.exports = __webpack_public_path__ + "media/images/Magna-4d4803041050456c6dcc3794fe3a8c72.png";